import { useAuth } from '@ox-technologies/auth';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { CUSTOM_AUTH_TOKEN } from 'config';
import { useEffect } from 'react';
import { protectedPaths } from 'utils/routing/routes';

export const useStoredPath = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const isSignedIn = isAuthenticated || !!CUSTOM_AUTH_TOKEN;

  useEffect(() => {
    const currentPath = location.pathname + location.searchStr;
    const storedPath = window.localStorage.getItem('stored-path');

    if (!isSignedIn && protectedPaths.includes(location.pathname))
      window.localStorage.setItem('stored-path', currentPath);

    if (isSignedIn && storedPath === currentPath)
      window.localStorage.removeItem('stored-path');

    // `href` because the stored path is a full "pathname + search" string
    if (isSignedIn && storedPath) navigate({ href: storedPath });
  }, [isSignedIn, location, navigate]);
};
